import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const AccountPageMenu = () => {
  const PAGE_TITLE = '< Account';
  const menulist = [
    {
      url: '/order-history',
      name: 'Order History',
    },
    {
      url: '/my-showroom',
      name: 'My Showroom',
    },
    {
      url: '/important-dates',
      name: 'Important Dates',
    },
    {
      url: '/address-book',
      name: 'Address Book',
    },
    {
      url: '/account-information',
      name: 'Account Details',
    },
    {
      url: '/account-influencer',
      name: 'Influencer Program',
    },
    {
      url: '/product-reviews',
      name: 'Product Reviews',
    },
    {
      url: '/communications',
      name: 'Newsletter Subscriptions',
    },
  ];

  const pathname = usePathname();

  return (
    <>
      <div className='hidden w-[270px] flex-none flex-col gap-y-[25px] pt-[60px] lg_flex'>
        {menulist.map((item, index) => (
          <Link
            className={clsx(
              ' text-base leading-5 ',
              'lg_hover_underline',
              pathname === item.url ? 'font-medium underline' : '',
            )}
            key={index}
            href={item.url}
          >
            {item.name}
          </Link>
        ))}
      </div>
      <Link
        className='text-xs leading-4 lg_hidden'
        href='/my-account'
      >
        {PAGE_TITLE}
      </Link>
    </>
  );
};

export default AccountPageMenu;
